import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-provider-modal-auditor-edit',
  templateUrl: './provider-modal-auditor-edit.component.html',
  styles: []
})
export class ProviderModalAuditorEditComponent extends ExcTranslation implements OnInit {
  auditor: {
    Salutation: string,
    Lastname: string,
    Firstname: string,
    Zip: string,
    Country: string,
    City: string,
    Street: string,
    Phone: number,
    Mobile: number,
    Email: string,
    Workdays: number,
    Workhours: number,
    ID: number
  } = {
    Phone: null,
    Mobile: null,
    Street: null,
    Email: null,
    Workdays: null,
    Workhours: null,
    Zip: null,
    City: null,
    Lastname: null,
    Firstname: null,
    Country: null,
    ID: null,
    Salutation: null
  };
  isEdit = false;
  addMore = false;
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
    const _self = this;
  }
  ngOnInit() {
    const _self = this;
    if (_self.overlayConfig.data.Data !== null) {
      Object.assign(_self.auditor, _self.overlayConfig.data.Data);
      if (_self.overlayConfig.data.Data.IsEdit !== undefined && _self.overlayConfig.data.Data.IsEdit !== null)  {
        _self.isEdit = _self.overlayConfig.data.Data.IsEdit;
      }
    }
    if (_self.overlayConfig.data['IsFirstCall'] === true) {
      _self.addMore = false;
    } else {
      _self.addMore = _self.overlayConfig.data['AddMore'];
    }
  }
  addAuditor() {
    const _self = this;
    _self.overlayRef.close({proceed: true, auditor: _self.auditor, AddMore: _self.addMore, IsFirstCall: _self.overlayConfig.data['IsFirstCall']});
  }
}
